import { render, staticRenderFns } from "./PostponeForm.vue?vue&type=template&id=ada8d85e"
import script from "./PostponeForm.vue?vue&type=script&lang=js"
export * from "./PostponeForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports